import { Context } from "../Engine";
import { ViewPort, Camera } from "../View";
import { Scene } from "../Scene";

export abstract class SceneRenderer {

    public abstract init(ctx: Context): void;

    public abstract destroy(): void;

    public abstract render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer): void;
}